import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const VOICE_POPOVER_WIDTH = 320;
export const VOICE_LIST_MAX_HEIGHT = 360;
export const VOICE_ROW_HEIGHT = 48;

export const useStyles = tss.create(({ theme }) => ({
  trigger: {
    width: '100%',
    minWidth: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.background.default,
    padding: '8px 32px 8px 42px',
    textAlign: 'start',
    fontFamily: 'inherit',
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:hover:not(:disabled)': {
      borderColor: theme.palette.primary.main,
    },
    '&:focus-visible': {
      outline: 'none',
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  triggerPlaceholder: {
    color: theme.palette.extendedGrey?.neutral ?? theme.palette.text.secondary,
  },
  triggerError: {
    borderColor: theme.palette.error.main,
    '&:hover:not(:disabled)': {
      borderColor: theme.palette.error.main,
    },
    '&:focus-visible': {
      borderColor: theme.palette.error.main,
      boxShadow: `0 0 0 2px ${theme.palette.error.light}`,
    },
  },
  popoverPaper: {
    width: VOICE_POPOVER_WIDTH,
    maxWidth: '92vw',
    borderRadius: 12,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0px 8px 24px ${alpha(theme.palette.extendedGrey.darker, 0.16)}`,
  },
  searchHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 12px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.default,
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: theme.palette.text.primary,
    fontSize: 14,
    lineHeight: 1.4,
    fontFamily: 'inherit',
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  searchClear: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 22,
    height: 22,
    border: 'none',
    borderRadius: '50%',
    background: 'transparent',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    padding: 0,
    fontFamily: 'inherit',
    '&:hover': {
      background: theme.palette.extendedGrey?.lighter,
      color: theme.palette.text.primary,
    },
  },
  list: {
    maxHeight: VOICE_LIST_MAX_HEIGHT,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '4px 0',
  },
  row: {
    width: '100%',
    height: VOICE_ROW_HEIGHT,
    border: 'none',
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    padding: '0 12px',
    cursor: 'pointer',
    textAlign: 'start',
    fontFamily: 'inherit',
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  rowActive: {
    background: theme.palette.action.hover,
  },
  rowSelected: {
    background: theme.palette.primary.light,
    '&:hover': {
      background: theme.palette.primary.light,
    },
  },
  rowTitle: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: theme.palette.text.primary,
    fontSize: 14,
  },
  providerBadge: {
    flexShrink: 0,
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    padding: '2px 6px',
    borderRadius: 999,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    background: theme.palette.background.default,
    maxWidth: 90,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  empty: {
    padding: '18px 12px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: 13,
  },
  checkIcon: {
    fontSize: 16,
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
}));
